import React, { useState, useEffect, useContext } from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import Cookies from "js-cookie";
import { useParams } from "react-router-dom";
import LayoutOperationBBtec from "../../components/LayoutOperationBBtec";
import { Header, Filter, TableMA } from "../../components/uih/ma_list";
import Api from "../../services/ServiceApi";
import { notification } from "antd";
import { changeLang } from "../../actions/langAction";
import { setDynamic } from "../../actions/dynamicAction";
import { setJobCategory } from "../../actions/metaDataAction";
import { authUserContext } from "../../contexts/authContext";
import axios from "axios";
import { getAreaList } from "../../utils/utils";

function Malist({
  // CompanyId,
  // OperatorId,
  // ProjectId,
  // ProjectData,
  setJobCategory,
  factUpdate,
  LangTranslate,
}) {
  // ! new coding
  const authUserValue = useContext(authUserContext);
  const [MAlist, setMAlist] = useState([]);

  const [MasterList, setMasterList] = useState([]);
  const [MAlistCount, setMAlistCount] = useState([]);
  const [refreshApi, setrefreshApi] = useState(999);
  const [isLoading, setisLoading] = useState(true);
  const [masterData, setMasterDatat] = useState([]);

  // filter state
  const [selectPriorityJob, setselectPriorityJob] = useState(0);
  const [selectjobType, setselectjobType] = useState("");
  const [selectSlalevel, setselectSlalevel] = useState("");
  const [jobCategory, setjobCategory] = useState([]);
  const [selectJobcategory, setselectJobcategory] = useState("");
  const [searchName, setsearchName] = useState("");
  const [formDate, setformDate] = useState("");
  const [toDate, settoDate] = useState("");
  const [actionBtn, setactionBtn] = useState([]);
  const [SelectJobstatus, setSelectJobstatus] = useState(1000); // 1000 = All Job
  const [statusDropdown, setstatusDropdown] = useState(null);
  const [selectAreaCode, setselectAreaCode] = useState([]); // useState(authUserValue.userArea);
  const [showonlyOwner, setshowonlyOwner] = useState(false);
  const [ShouldRefresh, setShouldRefresh] = useState(false);
  const [TabStatusIndex, setTabStatusIndex] = useState(0);
  const [advancedSearchFlag, setAdvancedSearchFlag] = useState(1);

  // const [factUpdate, setfactUpdate] = useState(false);
  // const [LangTranslate, setLangTranslate] = useState([]);

  const [employeeMMDropdown, setEmployeeMMDropdown] = useState(null);
  const [employeeSubDropdown, setEmployeeSubDropdown] = useState(null);

  const { company_id, operator_id, project_id } = useParams();

  const companyId = company_id || Cookies.get("companyid");
  const operatorId = operator_id || Cookies.get("operator_id");
  // const projectId = project_id || Cookies.get("project_id");
  // const [projectId, setProjectId] = useState(project_id || Cookies.get("project_id"));

  const [projectId, setProjectId] = useState("");
  const [PageSize, setPageSize] = useState(40);
  const [pageIndex, setPageIndex] = useState(1);

  const [cancelToken, setCancelToken] = useState(null);
  // console.log("selectAreaCode", selectAreaCode);
  const projectData = JSON.parse(localStorage.getItem("projectData"))?.filter(
    (data) =>
      +data.operator_id === +operatorId &&
      +data.company_id === +companyId &&
      +data.project_id === +projectId
  );

  const getProjectId = () => {
    if (project_id !== null && project_id !== undefined) {
      return project_id === "" ? "" : project_id;
    } else {
      const filterProjectdata = JSON.parse(
        localStorage.getItem("projectData")
      ).filter((data) => {
        return data.operator_id == Cookies.get("operator_id");
      });
      return operator_id === undefined ? filterProjectdata[0]?.project_id : "";
    }
  };

  useEffect(() => {
    const p = getProjectId();
    setProjectId(p);
    setselectAreaCode(getAreaList(p));
  }, []);

  // useEffect(() => {
  //   setselectAreaCode(getAreaList(projectId));
  // }, [projectId]);

  useEffect(() => {
    if (selectAreaCode.length === 0) {
      // Notify("Warning", "โปรดระบุ Area", "warning");
      return;
    }
    setisLoading(true);
    setMAlist([]);
    setMAlistCount([]);
    Api.post("master_data/job_category_single", {
      company_id: companyId,
      operator_id: operatorId,
      project_id: String(getProjectId()),
    }).then((res) => {
      // console.log("job_category_single >>> res", res.data);
      const { result, data } = res.data;
      console.log("result.code", result.code);
      if (result.code === "P") {
        setjobCategory(data.result);
        //redux
        setJobCategory(data.result);
        if (data.result.length > 0) {
          if (selectJobcategory === null) {
            // setselectJobcategory(data.result[0]?.job_category_id);
          }
        }
        getJobdetail(data.result[0]?.job_category_id);
      }
    });
    console.log("selectJobcategory", selectJobcategory);
    function getJobdetail(job_cat_id) {
      // const CancelToken = axios.CancelToken;
      // Cancel the previous request if it exists
      console.log("getJobdetail > cancelToken : ", cancelToken);
      if (cancelToken) {
        cancelToken.cancel("Canceling previous request");
      }

      const source = axios.CancelToken.source();
      setCancelToken(source);

      const getMalistAll = {
        category_name: selectJobcategory === "" ? null : selectJobcategory,
        company_id: companyId,
        job_type_name: selectjobType === "" ? null : selectjobType,
        operator_id: operatorId,
        project_id: String(getProjectId()),
        job_prority_id: selectPriorityJob === 0 ? null : selectPriorityJob,
        username: Cookies.get("username"),
        job_sla_name: selectSlalevel === 0 ? null : selectSlalevel,
        from_datetime: formDate === "" ? null : formDate,
        to_datetime: toDate === "" ? null : toDate,
        //area_code: null,
        area_code_list: selectAreaCode[0] === null ? null : selectAreaCode,
        search_text: searchName === "" ? null : searchName,
        MainProcessID:
          statusDropdown === null ? null : Number(statusDropdown.split("_")[0]),
        SubProcessID:
          statusDropdown === null ? null : Number(statusDropdown.split("_")[1]),
        // MainProcessID: null,
        // SubProcessID: null,
        owner_flag: false,
        employeeCodeMM: employeeMMDropdown,
        employeeCodeSub: employeeSubDropdown,
        tab_status: TabStatusIndex,
        job_status: SelectJobstatus === 1000 ? null : SelectJobstatus,
        PageSize:
          TabStatusIndex === 7 || TabStatusIndex === 8 ? 9999999 : PageSize,
        // PageSize: 999999,
        PageIndex: pageIndex,
        SortByField: null,
        SortBy: false,
        AdvancedSearchFlag: advancedSearchFlag,
      };
      const getMalistOwner = {
        category_name: selectJobcategory === "" ? null : selectJobcategory,
        company_id: company_id,
        job_type_name: selectjobType === "" ? null : selectjobType,
        operator_id: operatorId,
        project_id: String(getProjectId()),
        job_prority_id: selectPriorityJob === 0 ? null : selectPriorityJob,
        username: Cookies.get("username"),
        job_sla_name: selectSlalevel === 0 ? null : selectSlalevel,
        from_datetime: formDate === "" ? null : formDate,
        to_datetime: toDate === "" ? null : toDate,
        area_code_list: selectAreaCode[0] === null ? null : selectAreaCode,
        //area_code: null,
        search_text: searchName === "" ? null : searchName,
        MainProcessID:
          statusDropdown === null ? null : Number(statusDropdown.split("_")[0]),
        SubProcessID:
          statusDropdown === null ? null : Number(statusDropdown.split("_")[1]),
        owner_flag: true,
        employeeCodeMM: employeeMMDropdown,
        employeeCodeSub: employeeSubDropdown,
        tab_status: TabStatusIndex,
        job_status: SelectJobstatus === 1000 ? null : SelectJobstatus,
        PageSize:
          TabStatusIndex === 7 || TabStatusIndex === 8 ? 9999999 : PageSize,
        // PageSize: 999999,
        PageIndex: pageIndex,
        SortByField: null,
        SortBy: false,
      };

      console.log("showonlyOwner", showonlyOwner);
      if (showonlyOwner) {
        Api.postWithCancel("v4/search_ma_list_job_trs_data", getMalistAll, {
          cancelToken: source.token,
        })
          .then((res2) => {
            if (res2.data.result?.code === "P") {
              setMAlist(res2.data.data.data);
              setMasterList(res2.data.data.data || []);
              setMAlistCount([
                { job_status: 12345, count: res2.data.data.count },
              ]);
              getNextAction(job_cat_id);
            } else {
              Notify("Error", res2.data.result?.showText, "error");
            }
          })
          .catch((thrown) => {
            if (axios.isCancel(thrown)) {
              // Handle the cancellation
              console.log("Request canceled:", thrown.message);
            } else {
              // Handle other errors
              Notify("Error", thrown, "error");
            }
          });
      } else {
        Api.postWithCancel("v4/search_ma_list_job_trs_data", getMalistAll, {
          cancelToken: source.token,
        })
          .then((res2) => {
            if (res2.data.result?.code === "P") {
              setMAlist(res2.data.data.data);
              setMasterList(res2.data.data.data);
              setMAlistCount([
                { job_status: 12345, count: res2.data.data.count },
              ]);
              getNextAction(job_cat_id);
              // setShouldRefresh(false);
            } else {
              Notify("Error", res2.data.result?.showText, "error");
            }
          })
          .catch((thrown) => {
            if (axios.isCancel(thrown)) {
              // Handle the cancellation
              console.log("Request canceled:", thrown.message);
            } else {
              // Handle other errors
              Notify("Error", thrown, "error");
            }
          });
      }
    }

    function getNextAction(job_cat_id) {
      setisLoading(false);
      // Api.post("job_detail/get_next_action_by_job_category", {
      //   WF_ID: 0,
      //   CompanyID: Cookies.get("companyid"),
      //   OperatorID: Cookies.get("operator_id"),
      //   ProjectID: Cookies.get("project_id"),
      //   JobCategoryID: selectJobcategory || job_cat_id,
      //   MainProcessID: SelectJobstatus,
      //   SubProcessID: -1,
      //   UserName: Cookies.get("username"),
      // }).then((res) => {
      //   if (res.data.result?.code === "P") {
      //     setactionBtn(res.data.return_nextWorkFlow);
      //     setisLoading(false);
      //   } else if (res.data.result?.code === "F") {
      //     Notify("Error", res.data.result?.showText, "error");
      //   }
      // });
    }
  }, [
    refreshApi,
    showonlyOwner,
    ShouldRefresh,
    pageIndex,
    PageSize,
    selectAreaCode,
  ]);

  function Notify(title, msg, type) {
    const args = {
      message: title,
      description: msg,
      duration: 5,
      className: "font-thai-b",
    };
    notification[type](args);
  }

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        {/* <title>MaxiOperation - MA List / {projectData[0]?.project_name}</title> */}
        <title>MaxiOperation - MA List</title>
      </Helmet>
      <LayoutOperationBBtec layout={"position-fixed"}>
        <div>
          <div
            className="wrapper-header"
            // style={{ minHeight: "100px", height: "auto", marginTop: 50 }}
            style={{ padding: 0, height: 35, marginTop: 50 }}
          >
            <div
              className="container-fluid"
              style={{
                display: "flex",
                height: "100%",
                alignItems: "center",
                padding: 0,
                margin: 0,
              }}
            >
              <Header
                title={`MA List`}
                CompanyId={companyId}
                OperatorId={operatorId}
                ProjectId={String(getProjectId())}
                ProjectData={projectData}
              >
                {/* <div className="d-flex align-items-center mr-auto">
                    <img
                      src={Api.absoluteUrl("/icon/bbtec/header/MA-List.svg")}
                      className="mr-3"
                      alt={"MA List"}
                      title={"MA List"}
                      style={{ height: 20 }}
                    />
                    <h3
                      className="c-white text-uppercase mr-auto mt-0 mb-0"
                      style={{ fontFamily: "ThaiSansB" }}
                    >
                      {"MA List"} / {projectData[0]?.project_name}
                    </h3>
                  </div> */}
                <Filter
                  CompanyId={companyId}
                  OperatorId={operatorId}
                  ProjectId={String(getProjectId())}
                  ProjectData={projectData}
                  showonlyOwner={showonlyOwner}
                  setshowonlyOwner={setshowonlyOwner}
                  selectJobcategory={selectJobcategory}
                  jobCategory={jobCategory}
                  setjobCategory={setjobCategory}
                  setselectJobcategory={setselectJobcategory}
                  selectPriorityJob={selectPriorityJob}
                  setselectPriorityJob={setselectPriorityJob}
                  selectjobType={selectjobType}
                  setselectjobType={setselectjobType}
                  searchName={searchName}
                  setsearchName={setsearchName}
                  selectSlalevel={selectSlalevel}
                  setselectSlalevel={setselectSlalevel}
                  statusDropdown={statusDropdown}
                  setstatusDropdown={setstatusDropdown}
                  setShouldRefresh={setShouldRefresh}
                  setformDate={setformDate}
                  settoDate={settoDate}
                  selectAreaCode={selectAreaCode}
                  setselectAreaCode={setselectAreaCode}
                  employeeMMDropdown={employeeMMDropdown}
                  setEmployeeMMDropdown={setEmployeeMMDropdown}
                  employeeSubDropdown={employeeSubDropdown}
                  setEmployeeSubDropdown={setEmployeeSubDropdown}
                  setTabStatusIndex={setTabStatusIndex}
                  advancedSearchFlag={advancedSearchFlag}
                  setAdvancedSearchFlag={setAdvancedSearchFlag}
                />
              </Header>
            </div>
          </div>
          <div
            className="ma-list wrapper-body"
            style={{ padding: 0, marginTop: 0 }}
          >
            <div className="container-fluid" style={{ margin: 0, padding: 0 }}>
              <div className="align-content-md-start flex-wrap w-100">
                <TableMA
                  MasterListData={MasterList}
                  CompanyId={companyId}
                  OperatorId={operatorId}
                  ProjectId={String(getProjectId())}
                  ProjectData={projectData}
                  selectJobcategory={selectJobcategory}
                  dataS={MAlist}
                  selectPriorityJob={selectPriorityJob}
                  selectjobType={selectjobType}
                  searchName={searchName}
                  refresh={setrefreshApi}
                  refreshApi={refreshApi}
                  isLoading={isLoading}
                  setisLoading={setisLoading}
                  actionBtn={actionBtn}
                  setactionBtn={setactionBtn}
                  SelectJobstatus={SelectJobstatus}
                  setSelectJobstatus={setSelectJobstatus}
                  setTabStatusIndex={setTabStatusIndex}
                  factUpdate={factUpdate ? factUpdate : null}
                  LangTranslate={LangTranslate ? LangTranslate : null}
                  dataSCount={MAlistCount}
                  PageIndex={setPageIndex}
                  PageSize={setPageSize}
                  currentPageS={pageIndex}
                />
                {/* ) : null} */}
              </div>
            </div>
          </div>
        </div>
      </LayoutOperationBBtec>
    </>
  );
}

const mapStateToProps = (state) => ({
  lang: state.lang,
  dynamicReducer: state.dynamicReducer,
  factUpdate: state.masterLang.factUpdate,
  LangTranslate: state.masterLang.masterLang,
  layout: "position-fixed",
});
const mapDispacthToProps = (dispatch) => {
  return {
    changeLang: (data) => dispatch(changeLang(data)),
    setDynamic: (data, visible) => dispatch(setDynamic(data, visible)),
    setJobCategory: (data) => dispatch(setJobCategory(data)),
  };
};
export default connect(mapStateToProps, mapDispacthToProps)(Malist);
